import { render, staticRenderFns } from "./wistia-video.vue?vue&type=template&id=36068184"
import script from "./wistia-video.vue?vue&type=script&lang=ts"
export * from "./wistia-video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports